// extracted by mini-css-extract-plugin
export default {"inputAndLabel":"styles_inputAndLabel__EGIgz","label":"styles_label__mN2tb","input":"styles_input__2jSRa","textEditor":"styles_textEditor__o1yIP"};